import React, { useState } from "react";
import { Route, Switch, Link } from "react-router-dom";
import * as path from "constants/path";
import Loader from "storybookComponents/Loader";
import AppBar from "storybookComponents/Appbar";
import BreadCrumbs from "storybookComponents/Breadcrumbs";
import AppSwitcher from "components/AppSwitcher"
import CampaginList from "./content/CampaginList";
import CreateCampaign from "content/Campgain";
import { getGtmId } from "relay/main";
import { addUTMScript } from "public-routes/utils"
import Version from "storybookComponents/PopUp/version";
import { isLatest, getVersion, getDrawer, setVersion } from "services"

import { getDrawerState } from "common"
import UserContext from 'context/UserContext';
import Reports from "content/ReportsList"
import ExpiryNotificationPopup from "components/ExpiryNotificationPopup";
import UnAuthorizedUserPage from "./public-routes/unauthorized";
import ExpiredPage from "content/ExpiredPage";

const DefaultRoute = (props) => {

  React.useEffect(() => {

    let interval = setInterval(() => {
      if (props.propertyId) {
        clearInterval(interval);
        props.history.push(path.getAppPath())
      }
    }, 1000)

  }, [1])

  return <Loader />
}

export default React.memo(({
  classes,
  toggleDrawer,
  selected_org,
  selected_property,
  user,
  orgLevel,
  setOriginNavItems,
  propertyId,
  org,
  apps,
  expiredAt,
  unauth,
  isExpired,
  ...rest
}) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'pageview'
  });
  const { subOrgDetails } = React.useContext(UserContext);
  const [open, setOpen] = useState(true);
  const [showAppSwitcher, setShowAppSwitcher] = useState(false);
  const [pageTitle, setPageTitle] = useState('Referral Campaigns');
  const [loadingSetting, setLoadingSetting] = React.useState(false);
  const [isVersionLatest, setLatest] = React.useState(isLatest())
  const [later, setLater] = React.useState();
  const setActiveMenu = () => { }

  React.useEffect(() => {
    loadGtmId(propertyId)
  }, [subOrgDetails.id, subOrgDetails.org.id]);

  const loadGtmId = async (propertyId) => {
    try {
      setLoadingSetting(true)
      let response = await getGtmId(propertyId)
      if (response.websiteGtmScript) {
        addUTMScript(response.websiteGtmScript.noscript, response.websiteGtmScript.script);
        setLoadingSetting(false)
      }
    } catch (err) {
      console.log("err", err)
    }
  }

  const toggleAppSwitcher = () => {
    setShowAppSwitcher(!showAppSwitcher)
    setOpen(false);
    if (typeof toggleDrawer === "function")
      toggleDrawer();
  }

  const onBreadcrumbClickedCallback = (e, breadcrumb) => {
    if (breadcrumb.active_state !== true)
      window.location.replace(breadcrumb.link);
  }

  const onBreadcrumbIconClick = () => {
    if (pageTitle)
      window.location.replace(pageTitle[pageTitle.length - 2].link);
  }

  const getBreadcrumbs = (pathname) => {
    if (Array.isArray(pathname)) {
      pathname[pathname.length - 1].active_state = true;
      return pathname;
    }
    return [{ label: pathname, active_state: true }];
  }

  const handleLater = () => {
    setLatest(false);
    setLater(true);
  };

  const handleRefresh = () => {
    var latestVersion = getVersion().new;
    setVersion(latestVersion, latestVersion);
    setLatest(false);
    setLater(false);;
    handleCacheAndService();
  };

  const handleCacheAndService = () => {
    if (caches) {
      caches.keys().then(async function (names) {
        await Promise.all(names.map((name) => caches.delete(name)));
      });
    }
    window.location.reload(true);
  };


  return (
    <>
      {!isExpired && !unauth && <ExpiryNotificationPopup expiredAt={expiredAt} propertyId={propertyId} />}
      {
        loadingSetting ? <Loader /> :

          <div className={classes.appConatiner}>
            <div>
              <AppBar
                pageTitle={
                  <BreadCrumbs
                    xsWidth={window.innerWidth <= 600}
                    allBreadcrumbs={getBreadcrumbs(pageTitle)}
                    onBreadcrumbClickedCallback={onBreadcrumbClickedCallback}
                    onIconClick={onBreadcrumbIconClick}
                  />}
                onMenuIconClicked={toggleDrawer}
                notification={false}
                appswitcher
                onAppSwitcherClick={toggleAppSwitcher}
                no_shadow={false}
                no_border={false}
                xsWidth={Boolean(pageTitle) && typeof pageTitle === "object" && window.innerWidth <= 600}

              />
            </div>
            {
              isVersionLatest &&
              <Version
                orgLevel={orgLevel}
                arrow={
                  window.innerWidth >= 1280
                    ? getDrawer()
                    : window.innerWidth >= 1280
                }
                message={
                  <>
                    A < b > new version</b>{" "}
                    <span style={{ color: "#999" }}>(v{getVersion().new})</span>{" "}
                    of hyRaf is available.
                    <br />
                    <br />
                    Refresh to upgrade{" "}
                    <span style={{ color: "#999" }}>
                      (from v{getVersion().old})
                    </span>
                  </>
                }
                laterButton="Later"
                actionButton="Refresh"
                handleLater={handleLater}
                handleAction={handleRefresh}
              />

            }
            {
              showAppSwitcher ?
                <AppSwitcher
                  orgLevel={orgLevel}
                  org={{
                    id: subOrgDetails.org.id
                  }}
                  property={{
                    id: subOrgDetails.id,
                    propertyLogoUrl: subOrgDetails.propertyLogoUrl,
                    propertyManagerLogoUrl: subOrgDetails.propertyManagerLogoUrl,
                  }}
                  token={user.signInUserSession && user.signInUserSession.idToken.jwtToken}
                  closeAppSwitcher={toggleAppSwitcher}
                  apps={apps}
                /> :
                <>
                  {
                    unauth ? <Route path="/:propertyId">
                      {props => <UnAuthorizedUserPage unauth {...props} />}
                    </Route> :
                      expiredAt && isExpired ? <Route path="/:propertyId" component={ExpiredPage} /> :
                        <Switch>
                          <Route path="/" exact>
                            {
                              props => <DefaultRoute propertyId={subOrgDetails.id}  {...props} />
                            }
                          </Route>
                          <Route path={path.APP} exact>
                            {
                              props => <CampaginList  {...props} setTitle={setPageTitle} setActive={setActiveMenu} orgLevel={orgLevel} setOriginNavItems={setOriginNavItems} />
                            }
                          </Route>
                          <Route path={path.CREATE_CAMPAIGN} exact>
                            {
                              props => <CreateCampaign username={user.username} orgLevel={orgLevel} setOriginNavItems={setOriginNavItems} setTitle={setPageTitle} toggleDrawer={toggleDrawer} {...props} isDrawerOpen={Boolean(getDrawerState())}  {...rest} />
                            }
                          </Route>
                          <Route path={path.EDIT_CAMPAIGN} >
                            {
                              props => <CreateCampaign orgLevel={orgLevel} setOriginNavItems={setOriginNavItems} setTitle={setPageTitle} toggleDrawer={toggleDrawer} {...props} isDrawerOpen={Boolean(getDrawerState())}  {...rest} username={user.username} />
                            }
                          </Route>
                          <Route path={path.REPORT_PROPERTY} exact>
                            {
                              props => <Reports index={0} _view="allCampaign" {...props} setPageTitle={setPageTitle} />
                            }
                          </Route>
                          <Route path={path.REPORT_ALL_CAMPAIGN} exact>
                            {
                              props => <Reports index={1} _view="allCampaign" {...props} setPageTitle={setPageTitle} />
                            }
                          </Route>
                          <Route path={path.REPORT_CAMPAIGN}>
                            {
                              props => <Reports index={1} _view="singleCampaign" {...props} setPageTitle={setPageTitle} />
                            }
                          </Route>
                          <Route path={path.REPORT_CONTACT}>
                            {
                              props => <Reports index={2} _view="allCampaign" {...props} setPageTitle={setPageTitle} />
                            }
                          </Route>
                          <Route path={path.REPORT_ANALYTICS}>
                            {
                              props => <Reports {...props} _view="analytics" setPageTitle={setPageTitle} />
                            }
                          </Route>
                          <Route path="/">
                            {
                              props => <DefaultRoute propertyId={propertyId} {...props} />
                            }
                          </Route>
                        </Switch>
                  }
                </>
            }
          </div>
      }
    </>
  )
})